import { FC } from 'react'
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import {
  ModuleKpi,
  ModuleKpiAction,
  ModuleKpiContent,
  ModuleKpiGrid,
  ModuleKpiIcon,
  ModuleKpiLink,
  ModuleKpiTitle,
  ModulesPageHeader,
} from 'views/screens/Modules/styled'
import { useNotification } from 'lib/context/notification.context'
import { superAdminRoutes } from 'router/routes'

const QUESTIONNAIRE_ADMIN_ROLES = new Set(['special_admin', 'super_admin', 'platform_admin', 'super_platform_admin'])

const Home: FC = () => {
  const navigate = useNavigate()
  const { getWarning } = useNotification()
  const role = useSelector((state: any) => state.auth.role)
  const hasQuestionnaireManagement = useSelector((state: any) => state.user.hasQuestionnaireManagement)
  const canManageQuestionnaires = QUESTIONNAIRE_ADMIN_ROLES.has(role) && hasQuestionnaireManagement === true

  const handleQuestionnaireClick = () => {
    if (!canManageQuestionnaires) {
      getWarning('Comunícate con el administrador para habilitar esta función.')
      return
    }

    navigate(superAdminRoutes.Cuestionario)
  }

  return (
    <MainLayout>
      <ModulesPageHeader>
        <h2>Configuración módulo Betesa</h2>
      </ModulesPageHeader>

      <ModuleKpiGrid>
        {canManageQuestionnaires && (
          <ModuleKpi onClick={handleQuestionnaireClick} role="button" tabIndex={0}>
            <ModuleKpiIcon tone="pink">
              <AssignmentTurnedInOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Cuestionarios</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        )}

        <ModuleKpiLink to="/modules/talents/actions">
          <ModuleKpi>
            <ModuleKpiIcon tone="violet">
              <AutoAwesomeOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Acciones de desarrollo</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>

        <ModuleKpiLink to="/modules/talents/texts">
          <ModuleKpi>
            <ModuleKpiIcon tone="blue">
              <TextSnippetOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Textos</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>
      </ModuleKpiGrid>
    </MainLayout>
  )
}

export default Home
